<div class="container mt-3">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Bulk Reactivation</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="d-flex justify-content-center button-style mt-3">

                <!-- <button class="btn btn-secondary mb-3 ml-3" type="button" (click)="Refresh()" matButton><i
                        class="fa fa-refresh"></i> Refresh</button> -->
                <app-button (refreshClicked)="Refresh()" class="mb-3"></app-button>


                <div class="col-xl-4 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                        style="margin-bottom: 1rem !important;">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input formControlName="searchQuery" placeholder="Enter Customer Account Number" id="search"
                                matInput type="text" #searchInput>
                        </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                        (click)="search()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>
                </div>
                <button type="button" class="btn reset_btn" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> reset
                </button>
                <button class="btn btn-primary mb-3 ml-2" type="button" (click)="gotoaddsuspension()" matButton><i
                        class="fa fa-add"></i>
                    Add Bulk Suspension</button>
            </div>
            <div class="container mt-3" *ngIf="showdetailtable">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar">Customer Details</span>
                    </div>
                </div>
                <div class="card card_content">
                    <div class="table-responsive table-container mt-2 mb-4">
                        <mat-table #table [dataSource]="dataSource" class="mat-table ">

                            <ng-container matColumnDef="CustomerName">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;"> Customer
                                    Name</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.customerName}} </p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="CustomerNumber">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Customer
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                    <p class="text-truncate txtalign"> {{dataField.customerReferenceNumber}}</p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="ReferenceNumber">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;"> Reference
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.referenceNumber}} </p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Action">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Action</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;margin: 0;padding: 0;">

                                    <div class="text-truncate text-center">
                                        <div>
                                            <mat-checkbox [checked]="dataField.isRevoked" style="transform: scale(1.3);"
                                                (change)="clickaction(dataField)" color="primary"
                                                style="background-color: white;"></mat-checkbox>
                                                
                                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB; margin-left: 30px"
                                                *ngIf="dataField.eftDocumentId" class="fa fa-download" title="Download EFT Document"
                                                (click)="download(dataField.eftDocumentId)"></i>
                                        </div>
                                    </div>
                                </mat-cell>
                            </ng-container>



                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                            <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                            </mat-row>
                        </mat-table>
                        <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                            <p>No data found</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container mt-3" *ngIf="showrevoketable">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar">Bulk Reactivation</span>
                    </div>
                </div>
                <div class="card card_content">
                    <div class="table-responsive table-container mt-2 mb-4">
                        <mat-table #table [dataSource]="dataSource1" class="mat-table ">

                            <ng-container matColumnDef="CustomerName">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;"> Customer
                                    Name</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.customerName}} </p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="CustomerNumber">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Customer
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                    <p class="text-truncate txtalign"> {{dataField.customerReferenceNumber}}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="ApplicationStatus">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Application
                                    Status</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                    <p class="text-truncate txtalign"> {{dataField.applicationStatusTypeName}}</p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="ReferenceNumber">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;"> Reference
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.referenceNumber}} </p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Action">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Action</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;margin: 0;padding: 0;">

                                    <div class="text-truncate text-center">
                                        <div>
                                            <mat-checkbox [checked]="dataField.isRevoked" style="transform: scale(1.3);"
                                                (change)="clickaction(dataField)" color="primary"
                                                style="background-color: white;"></mat-checkbox>
                                        </div>
                                    </div>
                                </mat-cell>
                            </ng-container>



                            <mat-header-row *matHeaderRowDef="displayedColumns1; sticky:true"></mat-header-row>

                            <mat-row *matRowDef="let row; columns: displayedColumns1;  " matRipple>
                            </mat-row>
                        </mat-table>
                        <!-- <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                            <p>No data found</p>
                        </div> -->

                    </div>
                    <div class="d-flex justify-content-end button-style mt-3">
                        <button class="btn btn-primary mb-3" type="button" (click)="Revoke()" matButton>
                            Submit</button>
                    </div>
                </div>
            </div>
        </form>

    </div>

</div>